import { mapGetters, mapActions } from 'vuex';
import translation from '@elements/translation';

export default {
  mixins: [ translation ],
  computed: {
    ...mapGetters('formGuidedSearch', [
      'actualStep',
      'displayStepperModal',
      'stepperInfoModal',
      'getStepValue',
      'steps',
      'getUserData',
      'getUserDefaultInfosData',
      'getOffersCount',
      'getCustomSearchUrl',
      'actualStepTitle',
    ]),
    locationIsDisabled() {
      if (this.getLocationValues === null || !this.getLocationValues.locationChoice) {
        return true;
      }
      if (this.getLocationValues.locationChoice?.id === 0
        && (this.getLocationValues.locationTownInput === '' || this.getLocationValues.locationPostalCodeInput === '')) {
        return true;
      }

      if (this.getLocationValues.locationChoice?.id === 0 && (this.isLocationTownInputInvalid || this.isPostalCodeInvalid)) {
        return true;
      }
      return false;
    },
    getLocationValues() {
      return this.getStepValue('location');
    },
    isPostalCodeInvalid() {
      const exp = /^\w{1,5}$/;
      return !exp.test(this.getLocationValues.locationPostalCodeInput);
    },
    isLocationTownInputInvalid() {
      const exp = /^[^\d]+$/;
      return !this.getLocationValues.locationTownInput || !exp.test(this.getLocationValues.locationTownInput);
    },
    capacityIsDisabled() {
      return !this.getStepValue('capacity');
    },
    submitIsDisabled() {
      if (this.actualStep === 0) {
        return this.locationIsDisabled;
      }
      if (this.actualStep === 1) {
        return this.capacityIsDisabled;
      }
      if (this.actualStep === 2 && this.getStepValue('installationMonth') === null) {
        return true;
      }
      if (this.actualStep === 3 && this.getStepValue('duration') === null) {
        return true;
      }
      if (this.isStepBudgetDisabled || this.isStepBudgetMaxAmountExceeded) {
        return true;
      }
      if (this.isOrganizationDisabled) {
        return true;
      }
      if (this.isStepUserDisabled) {
        return true;
      }
      return false;
    },
    isStepBudgetDisabled() {
      const budget = this.getStepValue('budget');
      return this.actualStep === 4 && !budget.isUnknown && !budget.price;
    },
    isStepBudgetMaxAmountExceeded() {
      const budget = this.$store.getters['formGuidedSearch/getStepValue']('budget');
      return parseInt(budget.price, 10) > 99999999;
    },
    isOrganizationDisabled() {
      const organization = this.$store.getters['formGuidedSearch/getStepValue']('organization');
      return this.actualStep === 5 && (!organization || organization.trim() === '');
    },
    getUserData() {
      return this.getStepValue('user');
    },
    isStepUserDisabled() {
      return this.actualStep === 5 && (this.isUserNameInvalid || !this.getUserData.phoneNumberIsValid || !this.isUserEmailValid);
    },
    isUserNameInvalid() {
      const nameRegex = /^[^\d]+$/;
      return this.actualStep === 5 && (!this.getUserData.fullName || this.getUserData.fullName.trim() === '' || !nameRegex.test(this.getUserData.fullName));
    },
    isUserEmailValid() {
      const emailRegex = /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/i;
      return emailRegex.test(this.getUserData.email);
    },
  },
  methods: {
    ...mapActions('formGuidedSearch', {
      resetValue: 'RESET_VALUE',
      changeDisplayStepperModal: 'CHANGE_DISPLAY_STEPPER_MODAL',
      changeActualStep: 'CHANGE_ACTUAL_STEP',
      sendData: 'SEND_DATA',
    }),
    waitTime(time) {
      // eslint-disable-next-line no-promise-executor-return
      return new Promise((resolve) => setTimeout(resolve, time));
    },
  },
};
